import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./aata.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "../home/img2.png";
import ProductCard from "../../components/productCard/ProductCard";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";

const Aata = () => {
  return (
    <>
      <Navb />
      <div className="aatatop">
        <div className="aatatoptext">
          "Nandi Chakki Fresh Atta: <br /> Nourishing Every Meal, Every Day."
        </div>
        <img
          src={Img2}
          alt="Img2"
          style={{ display: "block", padding: "8px 50px 0px" }}
        />
      </div>

      <div className="whiteComponentsingleEcavo aatabg1">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Chakki Aata"
          text="Whole wheat Atta undergoes stone grinding, a method that imparts a
            distinct aroma and flavor to Rotis. Its authentic whole-grain
            composition, with a high bran content, makes it a fiber-rich food.
            This contributes to the regulation of digestion, blood sugar,
            cholesterol, obesity, and enhances skin quality, offering various
            health benefits. The temperatures reached during the chakki (stone
            mill or grinder) process, generated through friction, typically
            range from 110-125°C. At these elevated temperatures, the carotenes
            in the bran release a distinctive roasty fragrance, lending the atta
            its golden color."
          link1="/recipes/wholeattavegmomos"
          link1Text="View Recipes"
          link2="https://ecavo.shop/products/chakki-fresh-atta"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
          headingcss="whiteHeading"
          pcss="whiteP"
        />
      </div>
      <div className="productCards">
        <ProductCard
          Heading="Hygienic Production"
          Text="Nandi’s Chakki Fresh Atta is produced under stringent hygienic
              conditions, ensuring purity and safety in every bite. With quality
              control measures in place, you can trust that each serving of
              Nandi's Dalia meets the highest standards of cleanliness and food
              safety."
        />
        <ProductCard
          Heading="Premium Quality"
          Text="Nandi’s Chakki Fresh Atta is crafted from the finest grains, ensuring a superior quality product that consistently delivers excellent taste and texture in every dish."
        />
        <ProductCard
          Heading="Nutrient-Rich"
          Text="Packed with essential nutrients like fiber, vitamins, and minerals, Nandi’s Chakki Fresh Atta not only enhances the flavor of your meals but also contributes to your overall health and well-being."
        />
      </div>
      <Footer />
    </>
  );
};

export default Aata;
